/* eslint-disable react/prop-types */
import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`

`

const BlankLayout = ({ children }) => (<Wrapper>{children}</Wrapper>)

export default BlankLayout
